import { useRef, useState } from "react";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip/index.tsx";
import Utils from "../../../Utils";
import { formatDateWithTimezone } from "../../../utils/formatDateWithTimezone";

const QuotaDetailToolTip = ({ subscription, children }) => {
  const [expiringBalance, setExpiringBalance] = useState(() => (subscription.usesLedgers ? null : subscription.quota));
  const [nonExpiringBalance, setNonExpiringBalance] = useState(() => (subscription.usesLedgers ? null : subscription.packQuota));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const requestedRef = useRef(false);

  const loadLedgerDetails = async () => {
    if (!subscription.usesLedgers || requestedRef.current) {
      return;
    }
    requestedRef.current = true;
    setLoading(true);
    const result = await subscription.fetchLedgerDetails();
    if (result.success) {
      setExpiringBalance(result.data.expiringBalance);
      setNonExpiringBalance(result.data.nonExpiringBalance);
      setLoading(false);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  let hideTooltip = false;

  // words users that do not have pack quota should not see this tooltip
  if (!subscription.usesLedgers && !subscription.packQuota) hideTooltip = true;

  // credit users that do not have non-expiring credits should not see this tooltip
  if (subscription.usesLedgers && nonExpiringBalance !== null && nonExpiringBalance <= 0) hideTooltip = true;

  const consumable = subscription.usesLedgers ? "credits" : "words";

  let expiringVerb;

  // if the user has a rollover plan, we want to say "expire or rollover"
  if (subscription.usesLedgers) {
    const plan = subscription.currentPlan();

    if (plan?.rollover) {
      expiringVerb = "expire or rollover";
    } else {
      expiringVerb = "expire";
    }
  } else {
    expiringVerb = "expire";
  }

  if (hideTooltip) {
    return children;
  }

  return (
    <SudoTooltip
      position="bottom"
      triggerClassName='w-full'
      onOpenChange={(open) => {
        if (open) {
          loadLedgerDetails();
        }
      }}
      customContent={
        <>
          {loading && <div>Loading...</div>}
          {error && <div>Error loading credit details</div>}
          {!loading && !error && (
            <div className="text-xs">
              <strong>{Utils.numberWithCommas(expiringBalance)}</strong> {consumable} {expiringVerb} on {formatDateWithTimezone(subscription.nextProvisionDate())}. <br /> <br />
              <strong>{Utils.numberWithCommas(nonExpiringBalance)}</strong> {consumable} were purchased as a one-time pack and won't expire.
            </div>
          )}
        </>
      }
    >
      {children}
    </SudoTooltip>
  );
};

export default QuotaDetailToolTip;
